<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 10 10"
  >
    <defs><path d="M0 9.925h9.925V0H0v9.925z" /></defs>
    <g fill="none" fill-rule="evenodd">
      <path
        fill="#666"
        d="M9.925 3.722a.417.417 0 0 1-.413.413H6.617a.417.417 0 0 1-.414-.413.41.41 0 0 1 .123-.291l.892-.891a3.323 3.323 0 0 0-2.255-.886 3.3 3.3 0 0 0-2.818 1.577c-.154.252-.233.497-.342.756-.033.09-.097.148-.194.148H.323a.21.21 0 0 1-.207-.207v-.045C.672 1.589 2.578 0 4.963 0A5.02 5.02 0 0 1 8.38 1.37l.84-.834a.413.413 0 0 1 .29-.122c.227 0 .414.187.414.413v2.895zm-.168 2.32c-.549 2.287-2.436 3.883-4.82 3.883a4.951 4.951 0 0 1-3.399-1.37l-.833.834a.413.413 0 0 1-.291.123A.416.416 0 0 1 0 9.098V6.203c0-.226.187-.413.414-.413h2.894c.226 0 .414.187.414.413a.41.41 0 0 1-.123.291l-.885.885a3.299 3.299 0 0 0 5.066-.685c.155-.252.233-.497.342-.756.033-.09.097-.148.194-.148h1.24c.117 0 .208.097.208.207 0 .012 0 .032-.007.045z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ResetIcon',
};
</script>
